document.addEventListener('DOMContentLoaded', () => {
    const handleAccordionToggle = () => {
      if (window.innerWidth >= 750) {
        document.querySelectorAll('.footer-block__details').forEach((details) => {
          details.setAttribute('open', '');
        });
      } else {
        document.querySelectorAll('.footer-block__details').forEach((details, index) => {
          // Open the first one by default, close the others
          if (index === 0) {
            details.setAttribute('open', '');
          } else {
            details.removeAttribute('open');
          }
        });
      }
    };

    // Initial setup
    handleAccordionToggle();

    // Resize watcher
    window.addEventListener('resize', handleAccordionToggle);

    // Accordion close others logic
    document.querySelectorAll('.footer-block__details').forEach((details) => {
      details.querySelector('summary').addEventListener('click', (e) => {
        if (window.innerWidth >= 750) {
          e.preventDefault(); // Disable folding on desktop
          return;
        }
        const target = e.currentTarget.parentNode;
        if (!target.hasAttribute('open')) {
          document.querySelectorAll('.footer-block__details').forEach((other) => {
            if (other !== target) {
              other.removeAttribute('open');
            }
          });
        }
      });
    });
  });